/**
 * One definition of wheelspin for everything that talks about it: the HUD flag, the coach line and the throttle
 * drill's score. `rearSlip` (telemetry) is the rear slip ratio over the tyre's peak slip, so 1 is the top of the
 * grip curve: past it the tyre is spinning, not driving.
 */
export const WHEELSPIN_SLIP = 1;

export const isWheelspin = (t: { rearSlip: number; airborne: boolean }): boolean => !t.airborne && t.rearSlip >= WHEELSPIN_SLIP;
